import React, { useEffect } from 'react';
import Form, { useForm } from '../../../molecules/Form';
import Button from '../../../molecules/Button';
import { StyledTabSetComponents } from '../TabSetComponents.styles';
import Switch from '../../Switch';
import Field from '../../Field';

const TipConfigration = ({ title, data, deviceId, completeData, onSubmit }) => {
  const [form] = useForm();

  const handleSubmit = async e => {
    const payload = {
      id: deviceId,
      configuration: {
        ...completeData?.configuration,
        transaction_settings: {
          ...completeData?.configuration?.transaction_settings,
          tip_configuration: {
            _l: e?.Lock,
            _v: e?.visible,
            dollar_tip_amount: {
              amount_1: {
                value: e?.DollarAmount1,
              },
              amount_2: {
                value: e?.DollarAmount2,
              },
              amount_3: {
                value: e?.DollarAmount3,
              },
              value: e?.DollarTipAmount,
            },
            percentage_tip_amount: {
              amount_1: {
                value: e?.percentageAmount1,
              },
              amount_2: {
                value: e?.percentageAmount2,
              },
              amount_3: {
                value: e?.percentageAmount3,
              },
              value: e?.percentageTipAmount,
            },
            tip_screen: {
              value: e?.showTipScreen,
            },
          },
        },
      },
    };

    onSubmit(payload);
  };

  useEffect(() => {
    form.setFieldsValue({
      visible: data?._v,
      Lock: data?._l,
      showTipScreen: data?.tip_screen?.value,
      percentageTipAmount: data?.percentage_tip_amount?.value,
      percentageAmount1: data?.percentage_tip_amount?.amount_1?.value,
      percentageAmount2: data?.percentage_tip_amount?.amount_2?.value,
      percentageAmount3: data?.percentage_tip_amount?.amount_3?.value,
      DollarTipAmount: data?.dollar_tip_amount?.value,
      DollarAmount1: data?.dollar_tip_amount?.amount_1?.value,
      DollarAmount2: data?.dollar_tip_amount?.amount_2?.value,
      DollarAmount3: data?.dollar_tip_amount?.amount_3?.value,
    });
  }, [data, form]);
  return (
    <StyledTabSetComponents form={form} onSubmit={handleSubmit}>
      <div className="tab-body-header">
        <strong className="title">{title}</strong>
        <div className="switch-wrap">
          <Form.Item label="Visible" name="visible">
            <Switch />
          </Form.Item>
          <Form.Item label="Lock" name="Lock">
            <Switch label="Lock" />
          </Form.Item>
        </div>
      </div>
      <div className="tab-body-body noflex">
        <div className="mb">
          <Form.Item label="Show Tip Screen" name="showTipScreen">
            <Switch />
          </Form.Item>
        </div>
        <strong className="title">Select Tip Type</strong>

        <div className="col-wrapper">
          <div className="col">
            <div className="mb">
              <Form.Item label="Percentage Tip Amount" name="percentageTipAmount">
                <Switch />
              </Form.Item>
            </div>
            <div className="combine-fields form-control-custom">
              <Form.Item
                noMargin
                label="Percentage Amount 1"
                type="text"
                rounded
                name="percentageAmount1"
                lg
                placeholder="15"
                suffix="%">
                <Field />
              </Form.Item>
              <Form.Item
                noMargin
                label="Percentage Amount 2"
                type="text"
                rounded
                name="percentageAmount2"
                lg
                placeholder="18"
                suffix="%">
                <Field />
              </Form.Item>
            </div>
            <div className="form-control-custom">
              <Form.Item
                label="Percentage Amount 3"
                type="text"
                rounded
                name="percentageAmount3"
                lg
                placeholder="20"
                suffix="%">
                <Field />
              </Form.Item>
            </div>
          </div>
          <div className="col">
            <div className="mb">
              <Form.Item label="Dollar Tip Amount" name="DollarTipAmount">
                <Switch />
              </Form.Item>
            </div>
            <div className="combine-fields form-control-custom">
              <Form.Item
                noMargin
                label="Dollar Amount 1"
                type="text"
                rounded
                name="DollarAmount1"
                lg
                placeholder="15"
                suffix="%">
                <Field />
              </Form.Item>
              <Form.Item
                noMargin
                label="Dollar Amount 2"
                type="text"
                rounded
                name="DollarAmount2"
                lg
                placeholder="18"
                suffix="%">
                <Field />
              </Form.Item>
            </div>
            <div className="form-control-custom">
              <Form.Item
                label="Dollar Amount 3"
                type="text"
                rounded
                name="DollarAmount3"
                lg
                placeholder="20"
                suffix="%">
                <Field />
              </Form.Item>
            </div>
          </div>
        </div>
      </div>
      <div className="submission-wrapper">
        <Button width="140px">Confirm</Button>
      </div>
    </StyledTabSetComponents>
  );
};

export default TipConfigration;
